/// <amd-module name="Feed/Legacy/DataServices/ServiceEndpointDataService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IServiceEndpointRestClient } from "ServiceEndpoints/Client/RestClient/ServiceEndpoint";
import * as ServiceEndpoint from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export interface IServiceEndpointDataService extends IVssService {
    getServiceEndpointsAsync(projectId: string, type: string): Promise<ServiceEndpoint.ServiceEndpoint[]>;
}

class ServiceEndpointDataService extends VssService implements IServiceEndpointDataService {
    public async getServiceEndpointsAsync(projectId: string, type: string): Promise<ServiceEndpoint.ServiceEndpoint[]> {
        return this.getRestClient().getServiceEndpoints(projectId, type);
    }

    private getRestClient(): IServiceEndpointRestClient {
        return this.pageContext.getRestClient<IServiceEndpointRestClient>("ServiceEndpoint.IServiceEndpointRestClient");
    }
}

Services.add("IServiceEndpointDataService", { serviceFactory: ServiceEndpointDataService });
